import _ from 'lodash';
import CandidateWorkExperinceInfo from '../candidateWorkExperience/candidateWorkExperience';
import CandidateEducationInfo from '../candidateEducation/candidateEducation';
import CandidateCertificateInfo from '../candidateCertifications/candidateCertificates';
import CandidateAwardsInfo from '../candidateAwards/candidateawards';
import CandidateTechnicalProficiencies from '../candidateTechProficiency/candidateTechProficiency';
import { decodeJWT } from '../../../../services/candidateService';
const CandidateProfileContentPane = ({ currentNavigation, candidateData, fetchCandidateData, refreshPage }) => {
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const candidateId = _.get(decoded, 'username', '');

  if (!candidateData) {
    return <></>;
  }
  const { workExperience, educationalDetails } = candidateData;
  const currentRoles = _.get(workExperience, "currentRole", {}) || {}
  const previousRoles = _.get(workExperience, "previousJobs", []) || []
  const careerGaps = _.get(workExperience, "hasCareerGaps") === "YES"
    ? _.get(workExperience, "careerGaps", [])
    : [];
  switch (currentNavigation) {
    case 'experience':
      return (
        <CandidateWorkExperinceInfo
          candidateId={candidateId}
          candidateData={candidateData}
          jobRoles={[currentRoles, ...previousRoles]}
          careerGaps={careerGaps}
          fetchCandidateData={fetchCandidateData}
          refreshPage={refreshPage}
        />
      );


    case 'education':
      return <CandidateEducationInfo
        education={educationalDetails}
        candidateId={candidateId}
        candidateData={candidateData}
        fetchCandidateData={fetchCandidateData}
      />;
    case 'certification':
      return <CandidateCertificateInfo certificateDocs={_.get(educationalDetails, 'otherCertificates')}
        candidateId={candidateId}
        candidateData={candidateData}
        fetchCandidateData={fetchCandidateData}
      />;
    case 'awards':
      return <CandidateAwardsInfo
        awardDocs={_.get(workExperience, 'awards')}
        candidateId={candidateId}
        candidateData={candidateData}
        fetchCandidateData={fetchCandidateData} />;
    case 'technical-proficiency':
      return <CandidateTechnicalProficiencies
        techproficiencyDocs={_.get(workExperience, 'techProficiencies')}
        candidateId={candidateId}
        candidateData={candidateData}
        fetchCandidateData={fetchCandidateData}
      />;
  }
};

export default CandidateProfileContentPane;